module.exports = __webpack_public_path__ + "assets/img/bg-3ebb3e8a.jpg";